export type AnalyticsEventParams = Record<string, string | number | boolean | null | undefined>;

declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void;
  }
}

const sanitizeParams = (params: AnalyticsEventParams) => {
  const entries = Object.entries(params).filter(
    ([, value]) => value !== null && value !== undefined,
  );
  return Object.fromEntries(entries);
};

export const trackEvent = (name: string, params: AnalyticsEventParams = {}) => {
  if (typeof window === "undefined") return;
  const gtag = window.gtag;
  if (typeof gtag !== "function") return;
  gtag("event", name, sanitizeParams(params));
};
